import type { ComponentProps } from 'react';

const CopyIcon = ({ fill = '#8C98AB', ...props }: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.7066 6.20719L17.7925 4.29313C17.6066 4.10534 17.3503 4 17.0847 4H11.9722C10.8675 4 9.97219 4.89562 9.97219 6L9.9728 14C10.0003 15.1062 10.8972 16 12.0003 16H18.0003C19.1003 16 20.0003 15.1 20.0003 14V6.91406C20.0003 6.64906 19.8941 6.39469 19.7066 6.20719ZM18.5003 14C18.5003 14.2761 18.2764 14.5 18.0003 14.5H11.9722C11.696 14.5 11.4722 14.2761 11.4722 14V6.00406C11.4722 5.72794 11.6961 5.50406 11.9722 5.50406H15.9722L16.0003 7C16.0003 7.55219 16.4481 8 17.0003 8H18.4722V14H18.5003ZM12.5003 18C12.5003 18.2761 12.2764 18.5 12.0003 18.5H5.97219C5.696 18.5 5.47219 18.2761 5.47219 18L5.49969 10.0031C5.49969 9.727 5.72356 9.50313 5.99969 9.50313H9.00031V8H6C4.89531 8 4 8.89531 4 10L4.00031 18C4.00038 19.1031 4.89594 20 6.00031 20H12.0003C13.1003 20 14.0003 19.1 14.0003 18V17H12.5284L12.5003 18Z"
        fill={fill}
      />
    </svg>
  );
};
export default CopyIcon;
